exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tree-wrap .yxt-scrollbar__wrap{max-height:100% !important}\n", ""]);

